/**
 * Os últimos lotes de regra do catálogo, para achar o que está em andamento sem
 * guardar a URL (spec 2026-10-18 §5). Some quando não há lote nenhum.
 */
import { Link } from 'react-router-dom'
import { Anchor, Badge, Group, Stack, Text } from '@mantine/core'
import { useQuery } from '@tanstack/react-query'
import { listarLotes } from '@/api/waf'

export function LotesRecentes() {
  const lotes = useQuery({ queryKey: ['waf-lotes'], queryFn: listarLotes })
  const lista = (lotes.data ?? []).slice(0, 5)
  if (lista.length === 0) return null
  return (
    <Stack gap={4}>
      <Text size="sm" fw={600}>Lotes de regra do catálogo</Text>
      {lista.map((l) => (
        <Group key={l.id} gap="xs">
          <Anchor component={Link} to={`/security/waf/lotes/${l.id}`} size="sm">
            Lote {l.id}
          </Anchor>
          <Text size="sm" ff="monospace">{l.regra}</Text>
          <Text size="xs" c="dimmed">{l.total} WAF(s)</Text>
          {l.em_andamento > 0
            ? <Badge variant="light" color="blue">{l.em_andamento} em andamento</Badge>
            : <Badge variant="light" color="gray">sem item na fila</Badge>}
        </Group>
      ))}
    </Stack>
  )
}
